import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import { Color3, Vector2, Vector4 } from '@babylonjs/core/Maths/math';
import { PostProcess } from '@babylonjs/core/PostProcesses/postProcess';
import { Effect } from '@babylonjs/core/Materials/effect';

import { IShader, SHADER_SAMPLERS, SHADER_UNIFORMS } from '../Shader/shader';
import { SystemCamera } from '~src/System/systemCamera';
import { getRgbArrayFromString } from '~services/util';
import { ShaderInteraction } from '../Shader/shaderInteraction';

import cameraVertexShader from './camera.vertex.glsl';
import cameraFragmentShader from './camera.fragment.glsl';

Effect.ShadersStore.cameraVertexShader = cameraVertexShader;
Effect.ShadersStore.cameraFragmentShader = cameraFragmentShader;

export class ShaderCamera extends ShaderInteraction {
    private furyPostProcess: PostProcess;

    private furyEffect: Effect;

    constructor(system: SystemCamera, browser: HTMLElement) {
        super(system, browser);
        this.setNode(system.freeCamera);
        this.furyPostProcess = new PostProcess('fury post process', 'camera', SHADER_UNIFORMS, SHADER_SAMPLERS, 1, this.system.freeCamera);

        const int = setInterval(() => {
            if (this.furyPostProcess.isReady()) {
                this.furyEffect = this.furyPostProcess.getEffect();
                // this.checkShaderValues();
                this.isReady = true;
                this.initShader();
                this.setAndSaveShader(this._shader);
                clearInterval(int);
            }
        }, 200);

        //! Texture needs to be updated with onApply or it doesn't always work
        //! Same thing with effectScale and isLayer
        this.furyPostProcess.onApply = (effect) => {
            effect.setTexture('textureNoise', this.textureNoise);
            effect.setFloat('effectScale', 2);
            effect.setFloat('isLayer', 0);
        };
    }


    public setAndSaveShader(shader: IShader) {
        //! Need to do the chnage after render for camera postprocess
        this.system.addOnce(() => {
            this._setAndSaveShader(shader)
        })
    }

    public resetBackground() {
        const style = window.getComputedStyle(this.html, null);
        const backgroundColor = style.getPropertyValue('background-color');
        if (backgroundColor) {
            const bgCA = getRgbArrayFromString(backgroundColor);
            //! Important to have clear color match the background so that shader alpha is correct
            //! And clearColor needs to have alpha to 1 so that project thumbnail is correct
            const backColor = new Color3(bgCA[0] / 255, bgCA[1] / 255, bgCA[2] / 255);
            const { scene } = this.system;
            this.system.setFogColor(backColor);
            scene.clearColor = backColor.toColor4(1);
        }
    }

    protected setTextureMouseTrail(texture: Texture) {
        if (this.furyEffect) this.furyEffect.setTexture('textureMouseTrail', texture);
    }

    protected setTextureNoise(texture: Texture) {
        this.furyEffect.setTexture('textureNoise', texture);
    }

    // Camera Postprocess does not need textureSamepler as this is the scene
    protected setTextureSampler(texture: Texture) { }

    protected setTextureFrequency(frequency: number) {
        this.furyEffect.setFloat('textureFrequency', frequency);
    }

    protected setShaderValue(option: string, value: number) {
        this.furyEffect.setFloat(option, value);
    }

    protected setShaderColor(filter: string, color: number[]) {
        if (!color) return;
        const alpha = (color[3] !== undefined) ? color[3] : 1
        const hsl = new Color3(color[0], color[1], color[2]);
        this.furyEffect.setColor4(filter, hsl, alpha);
    }

    protected setShaderVector2(option: string, vector: Vector2) {
        this.furyEffect.setVector2(option, vector);
    }

    protected setShaderVector4(option: string, vector: Vector4) {
        this.furyEffect.setVector4(option, vector);
    }
}
